import { FunctionComponent, useEffect, useState } from "react"
import { PageTitle, PageContainer, Button } from "src/components/generic"
import { useAuth } from "src/context/AuthContext";
import ActionableItem from "src/components/dashboard/actionItems/ActionableItem";
import { userTypes } from "src/utils/types";
import { analysis, stripe } from "src/utils";

const ActionItems: FunctionComponent = () => {
    const { user } = useAuth();
    const [subscription, setSubscription] = useState<boolean>(false);
    
    const customerId = user?.metadata?.stripeId

    const profileProgress = user?.userType === userTypes.AccountTypes.CLIENT ? 
        analysis.calculations.clientProfileProgressPercent(user)
        : { percentCompleted: 0 };

    const subscriptionCheck = async () => {
        if(!customerId) return;
        try { 
            const result = await stripe.subscription.fetchSubscription(customerId);

            if(result?.status && result?.status === 'active') setSubscription(true);
        } catch(error) {
            console.log({error});
        }
    }

    useEffect(() => {
        subscriptionCheck();
    }, []);

    if(user?.userType !== userTypes.AccountTypes.CLIENT) return <p>Access Restricted</p>

    return (
        <PageContainer>
            <PageTitle title={`Welcome ${user?.userInfo?.name}`} />
            <h4 className="text-center">Please complete the action items below <b>prior to booking your appointment</b> or seeing a consultant.</h4>
            <div className="w-full max-w-md mx-auto my-4">
                <p className="text-sm font-medium text-gray-700 mb-2 text-center">
                    You have completed {profileProgress.percentCompleted}% of your profile
                </p>
                <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                    <div
                    className="bg-primary h-full rounded-full transition-all duration-500 ease-out"
                    style={{ width: `${profileProgress.percentCompleted}%` }}
                    ></div>
                </div>
            </div>


            <ActionableItem
                title="Financial Knowledge"
                description="Allows ClientVitals to understand your current financial knowlege and planning experiences, tools, and efforts."
                url={`/dashboard/neatt/financial-knowledge?client=${user?.userId}`}
                status={profileProgress.financialKnowledge.completed}
            />

            <ActionableItem
                title="Employment & Housing Information"
                description="Allows ClientVitals to understand your housing and employment history."
                url={`/dashboard/neatt/employment-info?client=${user?.userId}`}
                status={profileProgress.employmentInfo.completed}
            />

            <ActionableItem
                title="Lending Purpose"
                description="Allows ClientVitals to understand if you are seeking a loan, the kind of loan, and the amount."
                url={`/dashboard/neatt/lending-purpose?client=${user?.userId}`}
                status={profileProgress.loanType.completed}
            />

            <ActionableItem
                title="Financial History"
                description="Allows ClientVitals to understand your financial history, credit standing, and payment history"
                url={`/dashboard/neatt/financial-history?client=${user?.userId}`}
                status={profileProgress.financialHistory.completed}
            />

            <ActionableItem
                title="Financial Goals & Circumstances"
                description="Allows ClientVitals to understand your financial goals, processes, and circumstances for coming to us"
                url={`/dashboard/neatt/financial-goals?client=${user?.userId}`}
                status={profileProgress.financialGoals.completed}
            />
            
            {
                profileProgress.allCompleted && (
                    <ActionableItem
                        title="Pay & Schedule Appointment"
                        description="Allows you to pay for your appointment as well as pick the day and time that works best for you"
                        url={`/dashboard/neatt/appointment-payment?scid=${customerId}&type=ia`}
                        status={Boolean(user?.neatt?.intakeBooked)}
                    />
                )
            }

            <ActionableItem
                title="Claim ClientVitals MAP"
                description="Multi-Agency Preview of all 3 major repositories (EXP,EQF,TRU) viewable in notes. Most recent should be older than 90 days."
                url={`/dashboard/neatt/claim-map?scid=${customerId}&uid=${user?.userId}`}
                status={false}
                buttonText="Claim Now"
            />

            
        </PageContainer>
    )
}

export default ActionItems;